import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty, startCase } from "lodash";
import helpers from "../utils/helpers";
import AuthContext from "../context/AuthContext";
import ReactPaginate from "react-paginate";
import PaginationComp from "../components/PaginationComp";
import { isMobile } from "react-device-detect";
const Accountstatement = () => {
  let { user, isLoader, setLoader } = useContext(AuthContext);
  const params = useParams();
  const [getLogData, setLogData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 50,
  });
  const myStatementData = async () => {
    setLoader(true);
    const { status, data: response_users } = await apiGet(
      apiPath.transactionTxnLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
      }
    }
    setLoader(false);
  };

  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  useEffect(() => {
    setPageCount(getLogData?.totalPages || []);
  }, [getLogData]);

  useEffect(() => {
    myStatementData();
  }, [search_params]);

  let final =
    getLogData && getLogData.data[getLogData.data.length - 1]?.newBalance;
  return (
    <>
      {" "}
      <div className={isMobile ? "" : "main_wrap"}>
        <section className="main-inner-outer">
          <Container fluid>
            <div className="main_content_row">
              <Sidebar />

              <div className=" mt-3 my_account_main">
                <div className="inner-wrapper">
                  <h2 className="common-heading" style={{ float: "left" }}>
                    Account Statement
                  </h2>
                  {/* <Link
                  to={ `/InternationalCasionBets`}
                  className="green-btn"
                  style={{float:"left",marginLeft: "20px",marginBottom:"10px", marginTop:"-5px", padding:"5px"}}
                  >
                  International Casino Transaction
                </Link> */}
                  <section className="account-table">
                    <div className="profile-tab">
                      <div className="my_account_table_wrap">
                        <div className="table-main-wrapper">
                          <Table>
                            <thead>
                              <tr>
                                <th style={{textAlign:"left"}} scope="col">Date/Time</th>
                                <th scope="col">Deposit</th>{" "}
                                <th scope="col">WithDraw</th>
                                <th scope="col">Balance</th>
                                <th scope="col">Remark</th>
                                <th style={{textAlign:"right"}} scope="col">From/To</th>
                              </tr>
                            </thead>
                            <tbody>
                              {getLogData.data &&
                                getLogData.data.map((item, key) => {
                                  return (
                                    <tr>
                                      <td>
                                        {helpers.profileDate(
                                          item?.createdAt,
                                          user?.timeZone
                                        )}
                                      </td>
                                      <td>
                                        {item?.transactionType === "credit" ? (
                                          <span className="">
                                            {helpers.currencyFormat(
                                              item?.amount
                                            )}
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {" "}
                                        {item?.transactionType === "debit" ? (
                                          <span className="text-danger">
                                            {"(" +
                                              helpers.currencyFormat(
                                                item?.amount
                                              ) +
                                              ")"}
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </td>

                                      <td>
                                        {helpers.currencyFormat(
                                          item?.newBalance
                                        )}
                                      </td>
                                      <td width={"26%"}>
                                        {item?.remark || ""}
                                      </td>

                                      <td style={{textAlign:"right"}}>
                                        {startCase(
                                          item?.createdByData?.userType
                                        )}{" "}
                                        <img
                                          class="fromto"
                                          src={require("../assets/images/transparent.gif")}
                                        />
                                        {item?.userData?.username}
                                      </td>
                                    </tr>
                                  );
                                })}
                              {isEmpty(getLogData.data) ? (
                                <tr>
                                  <td colSpan={9}>No records found</td>
                                </tr>
                              ) : null}
                            </tbody>
                          </Table>
                          {/* <div className="bottom-pagination">
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel="Next"
                            // forcePage={viewpage}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={pageCount}
                            nextLabel="Prev"
                            renderOnZeroPageCount={null}
                            activeClassName="p-1"
                            activeLinkClassName="pagintion-li"
                          />
                        </div> */}
                          <PaginationComp
                            viewpage={0}
                            pageCount={pageCount}
                            handlePageClick={handlePageClick}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default Accountstatement;
